"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.index-of");

require("antd/lib/time-picker/style");

var _timePicker = _interopRequireDefault(require("antd/lib/time-picker"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireWildcard(require("react"));

require("./TimePicker.less");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = TimePicker;
exports.default = _default;
var TIMEPICKER_DEFAULT_FORMAT = 'HH:mm:ss';
/**
 * A time picker with automatic selection on click was needed.
 * This version tweaks Antd TimePicker to have Dropdown like behavior, with no footer.
 * Hiding OK button
 */

function TimePicker(_a) {
  var defaultOpen = _a.defaultOpen,
      onChange = _a.onChange,
      onOpenChange = _a.onOpenChange,
      onSelect = _a.onSelect,
      selectOnClick = _a.selectOnClick,
      value = _a.value,
      format = _a.format,
      rest = __rest(_a, ["defaultOpen", "onChange", "onOpenChange", "onSelect", "selectOnClick", "value", "format"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      val = _useState2[0],
      setVal = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultOpen),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var handleSelect = function handleSelect(value) {
    if (selectOnClick) {
      setVal(value);
    }

    if (onSelect) {
      onSelect(value);
    }

    if (onChange) {
      onChange(value, value.format(format || TIMEPICKER_DEFAULT_FORMAT));
    }
  };

  var handleOpenChange = function handleOpenChange(open) {
    setOpen(open);

    if (onOpenChange) {
      onOpenChange(open);
    }
  };

  var handleChange = function handleChange(value, dateString) {
    setVal(value);

    if (onChange) {
      onChange(value, dateString);
    }
  };

  var handleClick = function handleClick(event) {
    if (event.target) {
      /*
          Popup:
          ________________
          |hour| min| sec|
          |____|____|____|
          |____|____|____|
          |____|____|____|
          |____|____|____|
                      ^--- Last column
                ^--- this can be last column too
           ^--- also this one
           It depends on configuration, so we dont know which is going
           to be last column.
           When the popup is clicked we will check if clicked value is in
           last colunm, if so, we close the popup, otherwise we don't.
       */
      // we get clicked column element
      var parentUl = event.target.parentNode.parentNode; // we get all columms elements

      var columns = Array.from(parentUl.parentNode.children); // we check if clicked column element is last one

      if (columns.indexOf(parentUl) === columns.length - 1) {
        setOpen(false);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(_timePicker.default, Object.assign({
    popupClassName: (0, _classnames.default)('TimePicker_popup', {
      'TimePicker_popup--no-footer': selectOnClick
    }),
    panelRender: selectOnClick ? function (originPanel) {
      return /*#__PURE__*/_react.default.createElement("div", {
        onClick: handleClick
      }, originPanel);
    } : undefined,
    format: format,
    open: open,
    value: value || val,
    onOpenChange: handleOpenChange,
    onSelect: handleSelect,
    onChange: handleChange
  }, rest));
}